// extracted by mini-css-extract-plugin
export default {"nav":"PreferencesView_nav__nGOpU","main":"PreferencesView_main__baUin"};